import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-group-detail-form',
    templateUrl: './group-detail-form.component.html',
    styleUrls: ['./group-detail-form.component.less'],
    standalone: false
})
export class GroupDetailFormComponent implements OnInit {

  constructor(private dailogRef:MatDialogRef<GroupDetailFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private logger:NGXLogger,private formBuilder:FormBuilder) {
       this.dailogRef.disableClose=true;
    }

  groupDetailForm:FormGroup;
  ngOnInit(): void {
    this.initializeForm();
    if(this.data!=null && this.data.name!=null){
      this.groupDetailForm.patchValue(this.data);
    }
  }

  private initializeForm(): void {
    this.groupDetailForm=this.formBuilder.group({
      id:[],
      code:[],
      name:['',[Validators.required]],
    })
  }

  save(){
    this.groupDetailForm.markAllAsTouched();
    this.logger.info('Form Value',this.groupDetailForm.value);
    this.dailogRef.close(this.groupDetailForm.value);
  }

  trimControl(ctrl: AbstractControl) {
    if (ctrl?.value != null) {
      ctrl.setValue(ctrl.value.trim(), { emitEvent: false });
      ctrl.updateValueAndValidity();
    }
  }

  cancel(){
    this.groupDetailForm.reset();
    this.logger.info('Form Value',this.groupDetailForm.value);
    this.dailogRef.close();
  }

  get id(){ return this.groupDetailForm.get('id'); }
  get code(){ return this.groupDetailForm.get('code'); }
  get name(){ return this.groupDetailForm.get('name'); }

}
